import { useEffect, useState } from 'react';

/**
 * A custom React hook that returns the current dimensions of the window.
 * @returns {Object} - An object containing the height and width of the window.
 */
export default function useWindowDimension () {
    const [dimensions, setDimension] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });

    /**
     * Adds a resize event listener to the window and updates the dimension state
     * whenever the window is resized. Removes the event listener when the component
     * is unmounted.
     * @returns None
     */
    useEffect(() => {
        /**
         * Handles the resize event of the window and updates the dimensions state.
         * @returns None
         */
        function handleResize () {
            setDimension({
                height: window.innerHeight,
                width: window.innerWidth
            });
        }
        window.addEventListener('resize', handleResize);
        return () =>
            window.removeEventListener('resize', handleResize);
    });

    return dimensions;
}
